var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrSquares(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 7.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 7.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 15,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 22.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 30,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 30,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 22.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 15,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 7.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 7.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 22.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 37.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 45,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 52.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 52.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 45,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 45,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 52.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    y: 45,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 30,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 7.5,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 7.5,
    height: 7.5,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrSquares);
export default __webpack_public_path__ + "static/media/qr-squares.3bf91ffee3b26ec7badc3beb74ade0ab.svg";
export { ForwardRef as ReactComponent };